import React from "react";
import PropTypes from "prop-types";
import { Button, Type } from "discover.medical.react-component-library";
import { ALL_FILTER, PPC_FILTER } from "./constants";
import { FilterDivider } from "./_.styled";

export const Filters = ({ activeFilter, setActiveFilter, className }) => {
  const isAllFilterActive= activeFilter === ALL_FILTER;
  const isPPCFilterActive = activeFilter === PPC_FILTER;
  return (
    <div className={className}>
      <Button
        kind="text"
        padded={false}
        onClick={(e) => setActiveFilter(ALL_FILTER)}
      >
        <Type
          element="span"
          fontSize="sm"
          color={isAllFilterActive ? "gray800" : "anchor"}
          fontWeight={isAllFilterActive ? "bold" : "normal"}
        >
          All
        </Type>
      </Button>
      <FilterDivider vertical={true} />
      <Button
        kind="text"
        padded={false}
        onClick={(e) => setActiveFilter(PPC_FILTER)}
      >
        <Type
          element="span"
          fontSize="sm"
          color={isPPCFilterActive ? "gray800" : "anchor"}
          fontWeight={isPPCFilterActive ? "bold" : "normal"}
        >
          Potentially Practice-Changing Only
        </Type>
      </Button>
    </div>
  );
};

Filters.propTypes = {
  activeFilter: PropTypes.string,
  setActiveFilter: PropTypes.func,
  className: PropTypes.string,
};

export default Filters;
